// jQuery Mask
// mascara de telefone e celular
import 'jquery-mask-plugin';

export default class CustomMask {
  constructor(masks,elements) {
    this.masks = masks;
    this.elements = elements;
    this.maskBehaviorTel = function (value, event, field, options) {
      const isFirstMask = !(value.length > 14);
      const mask = masks[+isFirstMask];
      return mask;
    };
    
    this.init();
  } 

  init() {
    const maskBehaviorTel = this.maskBehaviorTel;
    this.elements.mask(maskBehaviorTel, {
      onKeyPress: function (val, e, field, options) {
        field.mask(maskBehaviorTel(val, e, field, options), options);
      }
    });
  }
}